<template>
    <MainLayout selectMenu="1-1" siderMenu="19-1" sideBar="fix">
        <div v-if="!hasAuth">
            <NoAuth></NoAuth>
        </div>
        <div v-else>

            <Row type="flex" class="main-content-row">
                <Col flex="1" class="left-fix-container">
                <div class="fix-record-block">
                    <fieldset class="my-fieldset ">
                        <legend class="my-legend">{{ getTranslation('p030') }}</legend>
                        <Alert type="success">
                            <div class="menu-actions">
                                {{ getTranslation('k221') }}:&nbsp;<DatePicker size="small" transfer type="daterange" placement="bottom-end"
                                    :placeholder="getTranslation('k220')" style="width: 210px" v-model="selectDate"
                                    format="yyyy-MM-dd">
                                </DatePicker>&nbsp;
                                {{ getTranslation('p025') }}：
                                <InputNumber :min="0" :max="959" size="small" style="width: 60px;" type="number"
                                    v-model="programBefore" />&nbsp;&nbsp;
                                {{ getTranslation('p026') }}：
                                <InputNumber :min="0" :max="959" size="small" style="width: 60px;" type="number"
                                    v-model="programAfter" />
                                <Button type="primary" style="margin-left: 10px;" @click="query" icon="ios-search"
                                    size="small">{{
                                        getTranslation('k176') }}</Button>
                            </div>
                        </Alert>
                        <div v-if="isLoadingQuery" class="flex-middle">
                            <LoadingBar :height="'100px'"/>
                        </div>
                        <div v-else v-for="(record, index) in fixRecord" :key="index"
                            style="display:inline-flex;margin-top:10px;">
                            <div class="one-fix table-cell"><Button :type="selectType(index)" size="small"
                                    shape="circle" @click="selectRecord(index)" :ref="'btn-record-' + index">{{
                                        cutYear(record[1].created_string) }}</Button>
                            </div>
                        </div>
                        <div v-if="!isLoadingQuery && fixRecord.length === 0" style="margin-top:10px;">
                            <Alert>{{ getTranslation('p027') }}</Alert>
                        </div>
                    </fieldset>
                </div>
                <fieldset class="my-fieldset second-fieldset">
                    <legend class="my-legend">{{ getTranslation('p060') }}</legend>
                    <Alert type="success">
                        <Row type="flex" class="menu-actions">
                            <Col flex="1" >
                            <Row type="flex">
                                <Col flex="6">
                                <Checkbox v-model="openTick">{{ getTranslation('p064') }}</Checkbox>：<InputNumber
                                    size="small" :min="0" style="width: 100px;" type="number" v-model="tickVal">
                                </InputNumber>&nbsp;μOhm&nbsp;
                                </Col>
                                <Col flex="1" class="flex-right">
                                <Button type="warning" :disabled="!canCreatRefCurve" size="small" icon="md-create"
                                    style="margin-left: 10px;" :loading="isCreatingRefCurve"
                                    @click="createRefCurve()">{{
                                        getTranslation('k104') }}</Button>
                                </Col>
                            </Row>

                            </Col>
                        </Row>
                    </Alert>
                </fieldset>
                <fieldset class="my-fieldset second-fieldset">
                    <legend class="my-legend">{{ getTranslation('p065') }}</legend>
                    <Row type="flex" class="menu-actions">
                        <Col flex="1">
                        <Alert type="success">
                            {{ getTranslation('p066') }}:&nbsp;<i-switch v-model="openSuffix" />
                            <template v-if="openSuffix">&nbsp;{{ getTranslation('p067') }}：<InputNumber size="small"
                                    style="width: 100px;" type="number" v-model="suffixVal" min:="0"></InputNumber>
                                &nbsp;μOhm&nbsp;{{ getTranslation('p068') }}</template>
                        </Alert>
                        </Col>

                    </Row>
                    <Row type="flex" class="menu-actions">
                        <Col flex="1">
                        <Alert type="success">
                            <Row type="flex">
                                <Col flex="6">
                                {{ getTranslation("p070") }}：<InputNumber size="small" style="width: 100px;"
                                    type="number" :min="0" v-model="refRangeUp"></InputNumber>&nbsp;μOhm&nbsp;
                                {{ getTranslation("p071") }}：<InputNumber size="small" style="width: 100px;"
                                    type="number" :min="0" v-model="refRangeDown"></InputNumber>&nbsp;μOhm&nbsp;
                                </Col>
                                <Col flex="1" class="flex-right">
                                <Button type="success" :disabled="!canSavingRefCurve" size="small"
                                    style="margin-left: 10px;" icon="ios-checkmark-circle-outline"
                                    @click="saveRefCurve()">{{ getTranslation('p028')
                                    }}</Button>
                                </Col>
                            </Row>

                        </Alert>
                        </Col>
                    </Row>
                </fieldset>
                </Col>
                <Col class="right-fix">
                <div v-if="isFromRecord">{{ getTranslation('p059') }}</div>
                <div v-else>{{ getTranslation('p061') }}</div>
                <div ref="charts" :style="{ width: chartWidth, height: '500px' }"></div>
                </Col>
            </Row>
        </div>
    </MainLayout>
</template>

<script>
import MainLayout from '@/components/MainLayout.vue'
import NoAuth from '@/components/NoAuth.vue'

import { API_URL } from '@/constants/const.js'
import axios from 'axios';
import { mapGetters, mapState } from 'vuex'
import { postJsError, jsonParseSafe, setDashboardPage, setSidbarBreadCrumb,formatUTCDate } from '@/util/util.js'
import LoadingBar from '@/components/LoadingBar.vue';

export default {
    name: 'FixIndex',
    components: {
        MainLayout,
        NoAuth, 
        LoadingBar,
    },
    props: {

    },
    data() {
        return {
            hasAuth: true,
            programBefore: 0,
            programAfter: 1,
            mac: '',
            fixRecord: [],
            yAxisDefine: [],
            chartWidth: '100%',
            myChart: null,
            isSelecting: false,
            startPos: null,
            xAxisData: [],
            aSeries: [],
            // track legend selections to persist toggle state
            legendSelected: {},
            // 多选状态与缓存
            selectedMap: {},        // { [index]: true }
            parsedCache: {},         // { [index]: { before: Curve[], after: Curve[] } }
            tickVal: 10,
            refRange: 10,
            // cache the grid rect during selection to keep alignment
            gridRect: null,
            isLoadingQuery: false,
            isFromRecord: false,
            openSuffix: false,
            suffixVal: 10,
            openTick: false,
            isCreatingRefCurve: false,
            refRangeDown: 10,
            refRangeUp: 10,
            selectDate: [new Date(), new Date()],
        }
    },
    computed: {
        ...mapGetters(['getTranslation']),
        ...mapState(['queryDate']),
        canCreatRefCurve() {
            return Object.keys(this.selectedMap).length > 0;
        },
        canSavingRefCurve() {
            return this.aSeries.some(s => s.key === 'fix-after-avg') && !this.isFromRecord;
        }
    },
    watch: {

    },
    created() {
        setDashboardPage('fix');
        this.mac = this.$route.query.mac;
        if (this.queryDate && this.queryDate.length > 0) {
            this.selectDate = [...this.queryDate]
        }
        this.initChart();
        this.initRefCurve();
    },
    mounted() {

    },
    methods: {
        initRefCurve() {
            let url = API_URL["fixInit"];
            let params = {
                mac: this.mac,
            }
            axios.get(url, {
                params: params
            })
                .then(res => {
                    if (res && res.data && res.data.code == 200) {
                        this.$store.commit('setBreadcrumbItems', [
                            { title: setSidbarBreadCrumb(res.data.data.machine), machine: res.data.data.machine }
                        ]);
                        const data = res.data.data.fix;
                        if (data && data.length > 0) {
                            let filteredData = data.filter(c => c && c.type == 1);
                            if (filteredData.length > 0) {
                                this.isFromRecord = true;
                                let oneFix = filteredData[0];
                                this.programBefore = oneFix.program_before;
                                this.programAfter = oneFix.program_after;
                                this.openTick = oneFix.open_tick == 1;
                                this.openSuffix = oneFix.open_suffix == 1;
                                this.tickVal = oneFix.tick_val;
                                this.suffixVal = oneFix.suffix_val;
                                this.refRangeDown = oneFix.ref_range_down;
                                this.refRangeUp = oneFix.ref_range_up;

                                const afterCurve = jsonParseSafe(oneFix.ref_res_curve_after);
                                if (Array.isArray(afterCurve) && afterCurve.length > 0) {
                                    this.xAxisData = Array.from({ length: afterCurve.length }, (_, i) => i);
                                    this.aSeries.push({
                                        key: "fix-after-avg",
                                        name: this.getTranslation('p039'),
                                        type: 'line',
                                        showSymbol: false,
                                        lineStyle: { width: 2, color: '#19be6b' },
                                        z: 20,
                                        data: afterCurve
                                    });
                                    this.reChart();
                                }
                            }
                        }

                    }
                })
        },
        async query() {
            this.isLoadingQuery = true;
            let url = API_URL["fixQuery"];
            let params = {
                mac: this.mac,
                program_before: this.programBefore,
                program_after: this.programAfter,
                start: formatUTCDate(this.selectDate[0]),
                end: formatUTCDate(this.selectDate[1]),
            }
            let res = await axios.get(url, {
                params: params,
                timeout:300000,
            })
            this.isLoadingQuery = false;
            let fixRecord = [];
            if (res && res.data && res.data.code == 200) {

                if (Array.isArray(res.data.data)) {
                    res.data.data.forEach(record => {
                        let hasCurve = true;
                        if (Array.isArray(record)) {
                            record.forEach(r => {
                                if (!r.Curves || r.Curves.length === 0) {
                                    hasCurve = false;
                                }
                            });
                        } else {
                            hasCurve = false;
                        }
                        if (hasCurve) {
                            fixRecord.push(record);
                        }
                    });
                }
            }
            this.fixRecord = fixRecord;

        },
        initChart() {
            this.$nextTick(() => {
                const parentWidth = this.$refs.charts.offsetWidth - 50;
                this.chartWidth = `${parentWidth}px`;
                this.myChart = this.$echarts.init(this.$refs.charts);
                // Initialize a base option so ECharts has a model before brush handlers run
                this.myChart.setOption({


                });

                this.setBrush();
            })
        },
        setBrush() {
            // 确保移除之前的事件监听器
            this.myChart.getZr().off('mousedown');
            //this.myChart.getZr().off('mousemove');
            this.myChart.getZr().off('mouseup');
            this.myChart.getZr().off('dblclick');

            // 绑定事件
            const zr = this.myChart.getZr();

            zr.on('mousedown', (e) => {
                if (e.event.which !== 1) return; // only left button

                // only activate brush inside the grid, ignore clicks on toolbox and elsewhere
                const modelReady = !!(this.myChart && this.myChart.getModel && this.myChart.getModel());
                if (!modelReady) return;
                const inGrid = this.myChart.containPixel('grid', [e.offsetX, e.offsetY]);
                if (!inGrid) return;
                this.isSelecting = true;
                this.startPos = { x: e.offsetX, y: e.offsetY };

                const gridModel = this.myChart.getModel().getComponent('grid', 0);

                if (gridModel) {
                    const grid = gridModel.coordinateSystem;
                    const rect = grid.getRect();

                    this.myChart.setOption({
                        graphic: {
                            id: 'selectionRect',
                            type: 'rect',
                            invisible: false,
                            shape: {
                                x: this.startPos.x,
                                y: rect.y,
                                width: 0,
                                height: rect.height
                            },
                            style: {
                                fill: 'rgba(150, 150, 150, 0.3)',
                                stroke: '#999',
                                lineWidth: 1,
                            },
                        }
                    });
                }
            });

            zr.on('mousemove', (e) => {
                if (this.isSelecting && this.startPos) {
                    const width = e.offsetX - this.startPos.x;
                    this.myChart.setOption({
                        graphic: {
                            id: 'selectionRect',
                            shape: { width }
                        }
                    });
                }
            });

            zr.on('mouseup', (e) => {
                if (this.isSelecting && this.startPos) {
                    this.isSelecting = false;

                    const endPos = { x: e.offsetX, y: e.offsetY };
                    const width = Math.abs(endPos.x - this.startPos.x);

                    if (width > 10) {
                        this.applyZoom(this.startPos.x, endPos.x);
                    }

                    this.myChart.setOption({
                        graphic: {
                            id: 'selectionRect',
                            invisible: true
                        }
                    });

                    this.startPos = null;
                }
            });

            zr.on('dblclick', (e) => {
                // only reset zoom when double-click happens inside the grid
                const modelReady = !!(this.myChart && this.myChart.getModel && this.myChart.getModel());
                if (!modelReady) return;
                const inGrid = this.myChart.containPixel('grid', [e.offsetX, e.offsetY]);
                if (!inGrid) return;

                this.myChart.dispatchAction({
                    type: 'dataZoom',
                    dataZoomId: 'dataZoomX',
                    start: 0,
                    end: 100
                });
            });
        },

        applyZoom(startPixel, endPixel) {
            const xAxis = this.myChart.getModel().getComponent('xAxis', 0);

            if (!xAxis) return;

            const axis = xAxis.axis;
            const pixelExtent = axis.getGlobalExtent();
            const minX = Math.min(startPixel, endPixel);
            const maxX = Math.max(startPixel, endPixel);

            // 确保在轴范围内
            const clampedMin = Math.max(minX, pixelExtent[0]);
            const clampedMax = Math.min(maxX, pixelExtent[1]);

            if (clampedMax <= clampedMin) return;

            // 计算百分比
            const startPercent = (clampedMin - pixelExtent[0]) / (pixelExtent[1] - pixelExtent[0]) * 100;
            const endPercent = (clampedMax - pixelExtent[0]) / (pixelExtent[1] - pixelExtent[0]) * 100;
            this.myChart.dispatchAction({
                type: 'dataZoom',
                dataZoomId: 'dataZoomX',
                start: startPercent,
                end: endPercent
            });
        },
        selectRecord(index) {
            if (this.selectedMap[index]) {
                // 反选
                this.$delete(this.selectedMap, index);
                this.rebuildFromSelections();
                return;
            }
            // 首次选择时校验并缓存
            if (!this.ensureRecordCached(index)) {
                return;
            }
            this.$set(this.selectedMap, index, true);
            this.isFromRecord = false;
            this.rebuildFromSelections();

        },
        selectType(index) {
            return this.selectedMap[index] ? 'success' : 'default';
        },

        // 校验并解析缓存指定记录；仅在首次选择时做一次
        ensureRecordCached(index) {
            if (this.parsedCache[index]) return true;

            const rec = this.fixRecord[index];
            if (!rec || !rec[0] || !rec[1]) {
                this.$Message.error(this.getTranslation('p029'));
                return false;
            }
            const before = rec[0].Curves;
            const after = rec[1].Curves;
            if (!before || !after) {
                this.$Message.error(this.getTranslation('p029'));
                return false;
            }
            const parseContent = (c) => {
                if (!c) return [];
                const v = c.content;
                if (Array.isArray(v)) return v;
                if (typeof v === 'string') {
                    try { return JSON.parse(v); } catch (e) { return []; }
                }
                return [];
            };

            const beforeCurves = before
                .filter(c => c && c.kind === 2)
                .map(c => ({ ...c, content: parseContent(c) }));
            const afterCurves = after
                .filter(c => c && c.kind === 2)
                .map(c => ({ ...c, content: parseContent(c) }));

            if (beforeCurves.length === 0 || afterCurves.length === 0) {
                this.$Message.error(this.getTranslation('p032'));
                return false;
            }
            let beforeContent = beforeCurves[0].content;
            let afterContent = afterCurves[0].content;
            if (!Array.isArray(beforeContent) || beforeContent.length === 0 ||
                !Array.isArray(afterContent) || afterContent.length === 0) {
                this.$Message.error(this.getTranslation('p029'));
                return false;
            }
            if (beforeContent.length !== afterContent.length) {
                this.$Message.error(this.getTranslation('p031'));
                return false;
            }
            let validCurve = this.aSeries.filter(s => s.key !== 'fix-after-avg');
            if (validCurve.length > 0) {
                const firstValidCurve = validCurve[0];
                if (beforeContent.length !== firstValidCurve.data.length ||
                    afterContent.length !== firstValidCurve.data.length) {
                    this.$Message.error(this.getTranslation('p033'));
                    return false;
                }
            }

            this.$set(this.parsedCache, index, {
                before: beforeCurves[0], after: afterCurves[0],
                before_create_at: rec[0].created_string,
                after_create_at: rec[1].created_string,
                "index": index
            });
            return true;
        },

        // 根据已选记录重建所有序列和X轴
        rebuildFromSelections() {
            const indices = Object.keys(this.selectedMap).map(k => parseInt(k, 10)).filter(k => this.selectedMap[k]);
            if (indices.length === 0) {
                // 清空图形
                this.xAxisData = [];
                const removedNames = new Set(this.aSeries.map(s => s.name));
                this.aSeries = [];
                // 清理 legendSelected 中已不存在的系列名                
                Object.keys(this.legendSelected).forEach(name => {
                    if (!removedNames.has(name)) {
                        // keep nothing since we are clearing chart
                    }
                });
                this.legendSelected = {};
                this.reChart();
                return;
            }

            // 计算所有已选曲线的统一长度（全局最小）
            let unifiedLen = Infinity;
            indices.forEach(idx => {
                const cache = this.parsedCache[idx] || {};
                const len = Array.isArray(cache.before.content) ? cache.before.content.length : 0;
                if (len > 0) unifiedLen = Math.min(unifiedLen, len);

            });
            if (!isFinite(unifiedLen) || unifiedLen <= 0) {
                this.$Message.error(this.getTranslation('p029'));
                return;
            }

            this.xAxisData = Array.from({ length: unifiedLen }, (_, i) => i);

            const newSeries = [];
            const newLegendNames = [];
            indices.forEach(idx => {
                const cache = this.parsedCache[idx];
                if (!cache) return;

                const cAfter = cache.after;
                const nameAfter = this.getTranslation('p035') + `-` + this.cutYear(cache.after_create_at);
                newSeries.push({
                    index: idx,
                    name: nameAfter,
                    type: 'line',
                    showSymbol: false,
                    data: (cAfter.content || []).slice(0, unifiedLen)
                });
                newLegendNames.push(nameAfter);

            });

            // 合并旧的 legend 选择状态，新增默认选中，已删除自动丢弃
            const mergedSelected = {};
            newLegendNames.forEach(n => {
                // eslint-safe own check
                mergedSelected[n] = Object.prototype.hasOwnProperty.call(this.legendSelected, n)
                    ? this.legendSelected[n]
                    : true;
            });
            this.legendSelected = mergedSelected;

            this.aSeries = newSeries;
            this.reChart();
        },

        // ...existing code reChart remains; it already uses array-form axes and legend selections...
        reChart() {
            const legendData = this.aSeries.map(s => s.name);
            const selected = {};
            legendData.forEach(n => {
                selected[n] = Object.prototype.hasOwnProperty.call(this.legendSelected, n)
                    ? this.legendSelected[n]
                    : true;
            });
            this.legendSelected = selected;

            this.myChart.setOption({
                // reserve space so legend never overlaps the chart
                grid: {
                    top: 20,
                    left: 10,
                    right: 10,
                    bottom: 64,          // space for the scroll legend
                    containLabel: true
                },
                xAxis: [{
                    axisLine: { onZero: true },
                    type: 'category',
                    boundaryGap: false,
                    splitLine: { show: true },
                    axisLabel: {
                        formatter: function (value) {
                            const v = parseInt(value, 10);
                            return isNaN(v) ? value : String(v);
                        }
                    },
                    data: this.xAxisData
                }],
                yAxis: [{
                    axisLine: { onZero: true },
                    type: 'value'
                }],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { type: 'line' },
                    formatter: (params) => {
                        let tooltipText = '';
                        if (Array.isArray(params)) {
                            params.forEach(p => {
                                if (p && p.seriesName) {
                                    tooltipText += `${p.seriesName}: ${p.data}<br/>`;
                                }
                            });
                        }
                        return tooltipText;
                    },
                    confine: true
                },
                // make legend scrollable and stick to the bottom
                legend: {
                    type: 'scroll',
                    // orient: 'horizontal',
                    bottom: 0,
                    left: 10,
                    right: 10,
                    data: legendData,

                },
                series: this.aSeries,
                dataZoom: [
                    {
                        id: 'dataZoomX',
                        type: 'slider',
                        xAxisIndex: 0,
                        bottom: 30,
                        filterMode: 'empty',
                        showDataShadow: true,
                        start: 0,
                        show: false,
                        end: 100
                    },

                ],
            }, true);
        },
        createRefCurve() {
            this.isCreatingRefCurve = true;
            const indices = Object.keys(this.selectedMap)
                .map(k => parseInt(k, 10))
                .filter(k => this.selectedMap[k]);

            if (indices.length === 0) {
                this.$Message.error(this.getTranslation('p036'));
                this.isCreatingRefCurve = false;
                return;
            }
            if (!this.tickRangeCurve()) {
                this.isCreatingRefCurve = false;
                return;
            }

            // 收集所有已选的修磨前/修磨后曲线内容（数组）
            const beforeList = [];
            const afterList = [];
            indices.forEach(idx => {
                const cache = this.parsedCache[idx];
                if (!cache) return;
                const c = cache.before;
                if (Array.isArray(c.content) && c.content.length > 0) beforeList.push(c.content);

                const cAfter = cache.after;
                if (Array.isArray(cAfter.content) && cAfter.content.length > 0) afterList.push(cAfter.content);
            });

            if (beforeList.length === 0 && afterList.length === 0) {
                this.$Message.error(this.getTranslation('p036'));
                this.isCreatingRefCurve = false;
                return;
            }


            // 统一长度：优先使用当前xAxis长度，否则取所有曲线的最小长度
            let unifiedLen = this.xAxisData && this.xAxisData.length > 0 ? this.xAxisData.length : Infinity;
            const allLists = beforeList.concat(afterList);
            allLists.forEach(arr => {
                if (Array.isArray(arr) && arr.length > 0) {
                    unifiedLen = Math.min(unifiedLen, arr.length);
                }
            });

            if (!isFinite(unifiedLen) || unifiedLen <= 0) {
                this.$Message.error(this.getTranslation('p037'));
                this.isCreatingRefCurve = false;
                return;
            }
            if (!this.xAxisData || this.xAxisData.length === 0) {
                this.xAxisData = Array.from({ length: unifiedLen }, (_, i) => i);
            }

            // 计算平均曲线
            const averageSeries = (lists) => {
                return Array.from({ length: unifiedLen }, (_, i) => {
                    let sum = 0;
                    let cnt = 0;
                    for (const arr of lists) {
                        const v = arr[i];
                        if (typeof v === 'number' && !isNaN(v)) {
                            sum += v;
                            cnt++;
                        }
                    }
                    return cnt ? +(sum / cnt).toFixed(3) : null;
                });
            };

            const afterAvg = afterList.length ? averageSeries(afterList) : null;

            // 移除旧的参考曲线            
            this.aSeries = this.aSeries.filter(s => s.key !== 'fix-after-avg');

            if (afterAvg) {
                this.aSeries.push({
                    index: -1,
                    key: "fix-after-avg",
                    name: this.getTranslation('p039'),
                    type: 'line',
                    showSymbol: false,
                    lineStyle: { width: 2, color: '#19be6b' },
                    z: 20,
                    data: afterAvg
                });
                this.legendSelected[this.getTranslation('p039')] = true;
            }

            this.reChart();
            this.isCreatingRefCurve = false;
        },
        tickRangeCurve() {
            let rs = true;
            if (this.openTick) {
                this.tickVal = Number(this.tickVal);
                if (isNaN(this.tickVal) || this.tickVal <= 0) {
                    this.$Message.error(this.getTranslation('p063'));
                    return false;
                }

                let allCurves = this.aSeries.filter(s => s.key !== 'fix-after-avg');
                let allData = [];
                for (let s of allCurves) {
                    if (Array.isArray(s.data)) {
                        for (let v of s.data) {
                            allData.push(v);
                        }
                    }
                }
                let avgAll = allData.reduce((sum, value) => sum + value, 0) / allData.length;
                let hasOutOfRange = false;
                for (let s of allCurves) {
                    if (Array.isArray(s.data)) {
                        let oneAve = s.data.reduce((sum, value) => sum + value, 0) / s.data.length;
                        if (Math.abs(oneAve - avgAll) > this.tickVal) {
                            if (s.index > -1) {
                                hasOutOfRange = true;
                                // 直接调用selectRecord方法，而不是模拟点击
                                this.selectRecord(s.index);
                            }
                        }
                    }
                }
                if (hasOutOfRange) {
                    this.$Message.warning(this.getTranslation('p069'));
                }
            }
            return rs;

        },
        saveRefCurve() {
            const curveAfter = this.aSeries.find(s => s.key === 'fix-after-avg');
            if (!curveAfter) {
                this.$Message.error(this.getTranslation('p040'));
                return;
            }
            if (!this.checkRefParam()) {
                return;
            }
            let url = API_URL["fixSaveRefCurve"];
            let params = new FormData();
            params.append('mac', this.mac);
            params.append('program_after', this.programAfter);
            params.append('program_before', this.programBefore);
            params.append('ref_res_curve_after', JSON.stringify(curveAfter.data));
            params.append('open_tick', this.openTick ? '1' : '0');
            params.append('tick_val', this.tickVal);
            params.append('open_suffix', this.openSuffix ? '1' : '0');
            params.append('suffix_val', this.suffixVal ? this.suffixVal : '0');
            params.append('ref_range_up', this.refRangeUp);
            params.append('ref_range_down', this.refRangeDown);
            axios.post(url, params)
                .then(res => {
                    if (res && res.data && res.data.code == 200) {
                        this.$Message.success(res.data.msg);
                    } else if (res && res.data && res.data.msg) {
                        this.$Message.error(res.data.msg);
                    } else {
                        this.$Message.error(this.getTranslation('c001'));
                    }
                })
                .catch(err => {
                    postJsError(err)
                    this.$Message.error(this.getTranslation('c001'));
                });
        },
        checkRefParam() {
            let rs = true;            
            if (this.programAfter === null || this.programBefore === null || isNaN(this.programAfter) || isNaN(this.programBefore)) {
                this.$Message.error(this.getTranslation('p072'));
                return false;
            }
            if (this.openTick) {
                this.tickVal = Number(this.tickVal);
                if (isNaN(this.tickVal) || this.tickVal <= 0) {
                    this.$Message.error(this.getTranslation('p063'));
                    return false;
                }
            }
            if (this.openSuffix) {
                this.suffixVal = Number(this.suffixVal);
                if (isNaN(this.suffixVal) || this.suffixVal <= 0) {
                    this.$Message.error(this.getTranslation('p073'));
                    return false;
                }
            }
            if (this.refRangeUp <= 0 || this.refRangeDown <= 0) {
                this.$Message.error(this.getTranslation('p074'));
                return false;
            }
            return rs
        },
        cutYear(dateString) {
            if (!dateString || dateString.length < 4) return dateString;
            return dateString.substring(5);
        }
    }
}
</script>

<style scoped>
@import url("../../assets/style/list.css");
@import url("../../assets/style/tab.css");

.fix-record-block {
    margin-top: 10px;
    width: 100%;
    max-height: 500px;
    overflow-y: auto;
}

.one-fix {
    display: inline-flex;
    margin-right: 10px;
}

.right-fix {
    padding-left: 4px;
    height: calc(100vh - 260px);
    overflow-y: auto;
    overflow-x: hidden;
    flex: 0 0 600px;
    /* adjust fixed width as needed */
    max-width: 600px;
}

.second-fieldset {
    margin-top: 10px;
}
</style>